import { object, string, ref } from 'yup';

import {
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_PATTERN,
} from '@/constants';
import i18n from '@/settings/i18n';

export const passwordSchema = object({
  currentPassword: string().required(
    i18n.t('ui.password.current.error.required'),
  ),
  newPassword: string()
    .min(
      PASSWORD_MIN_LENGTH,
      i18n.t('ui.error.minlength', { length: PASSWORD_MIN_LENGTH }),
    )
    .max(
      PASSWORD_MAX_LENGTH,
      i18n.t('ui.error.maxlength', { length: PASSWORD_MAX_LENGTH }),
    )
    .matches(PASSWORD_PATTERN, i18n.t('ui.password.error.format'))
    .required(i18n.t('ui.error.required.input'))
    .notOneOf([ref('currentPassword')], i18n.t('ui.password.error.duplicated')),
}).required();
